export class RegularExpressions {
  address: string;
  alphaNumeric: string;
  numeric: string;
  decimal4: string;
  decimal32: string;
  decimal92: string;
  city: string;
  country: string;
  date: string;
  department: string;
  firstName: string;
  individualId: string;
  lastName: string;
  middleInitial: string;
  phone: string;
  phoneExtension: string;
  ssn: string;
  state: string;
  title: string;
  zipCode: string;
  emailAddress: string;
  emailAddressesList: string;
  allExceptMaliciousCode: string; // Allow special characters except malicious code like <script>
  postalCodes: string;
  notWhiteSpaces: string;
}
